import React from "react";
import { useUserContext } from "../context/userContext";
import Auth from "../components/auth/Auth";
import { useState, useEffect } from "react";
import account from "../public/account.svg"

import { useContext } from "react";
import { DarkModeContext } from "../components/DarkModeProvider"

import { useAuth, upload } from "../firebase";


const ProfileLoaded = () => {
  const { user, logoutUser, DeleteUser } = useUserContext();

  const { darkMode } = useContext(DarkModeContext);
  

  const currentUser = useAuth();
  const [photo, setPhoto] = useState(null);
  const [ ,setLoading] = useState(false);
  const [photoURL, setPhotoURL] = useState("");

  function handleChange(e) {
    if (e.target.files[0]) {
      setPhoto(e.target.files[0])
    }
  }

  function HandleClick() {
    upload(photo, currentUser, setLoading);
  }

  useEffect(() => {
    if (currentUser?.photoURL) {
      setPhotoURL(currentUser.photoURL)
    }
  }, [currentUser])



  return (
    <>
    <div className="container">
        <div className="profile__content">
            <div className={darkMode ? 'profile__content--left dark-box' : 'profile__content--left light-box'}>
                <div className="profile__content--top">

                <div class="personal-image">
                  <label class="label">
                    <input type="file" onChange={handleChange} />
                    <figure class="personal-figure">
                    {photoURL ? <img width={110} height={110} src={photoURL} alt="Avatar" className="avatar" class="personal-avatar" /> : <img width={150} height={150} src={account} alt="Avatar" className="avatar" />}
                      <figcaption class="personal-figcaption">
                        <img src="https://raw.githubusercontent.com/ThiagoLuizNunes/angular-boilerplate/master/src/assets/imgs/camera-white.png" alt="Photos" />
                      </figcaption>
                    </figure>
                  </label>
                </div>
                    <button className={darkMode ? 'profile__content--button upload--button dark-button-text' : 'profile__content--button upload--button'} onClick={HandleClick}>
                      <span>Nahrát obrázek</span>
                    </button>
                </div>
                
                <div className="profile__content--center">
                  <h3 className={darkMode ? 'light-text' : 'dark-text'}>Informace</h3>
                </div>

                <div className="profile__content--bottom">
                    <button onClick={logoutUser} className={darkMode ? 'profile__content--button computer dark-button-text' : 'profile__content--button computer'}>
                        <span>Odhlásit se</span>
                    </button>
                </div>
            </div>

            <div className={darkMode ? 'profile__content--right dark-box' : 'profile__content--right light-box'}>
                <div className="profile__content--info">
                    <h2 className={darkMode ? 'light-text' : 'dark-text'}>Uživatelské informace</h2>
                    <div className="profile__content--name">
                        <h4 className={darkMode ? 'light-text' : 'dark-text'}>Jméno</h4>
                        <h4 className={darkMode ? 'light-text' : 'dark-text'}>{user.displayName}</h4>
                    </div>
                    <div className="profile__content--email">
                        <h4 className={darkMode ? 'light-text' : 'dark-text'}>Email</h4>
                        <h4 className={darkMode ? 'light-text' : 'dark-text'}>{user.email}</h4>
                    </div>
                </div>
                <div className="profile__content--info--second">
                    <button onClick={DeleteUser} className={darkMode ? 'profile__content--button dark-button-text' : 'profile__content--button '}>
                            <span>Smazat účet</span>
                    </button>
                    <button onClick={logoutUser} className={darkMode ? 'profile__content--button profile__content--button--mobile dark-button-text' : 'profile__content--button profile__content--button--mobile'}>
                        <span>Odhlásit se</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    </>
  );
};

const Profile = () => {
  const { loading, user } = useUserContext();

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <div className={darkMode ? 'profile dark' : 'profile light'}>
        {loading ? (
            <div className="loading">
                <h2 className={darkMode ? ' dark-text' : ' light-text'}>Loading...</h2>
            </div>
        ) : (
          <>
            {user ? <ProfileLoaded /> : <Auth />}
          </>
        )}
      </div>
    </>
  );
};

export default Profile;
